export default __webpack_public_path__ + "static/media/FullScreenExitIcon.6c6a8592.svg";